import { Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { QuestionIcon } from './icons';

export const FaqBox = ({ title = '', description = '' }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div
        style={{
          width: '100%',
          background: open ? '#F4F4F4' : '#fff',
          borderRadius: '20px',
          padding: '15px',

          border: '1px solid #DDD',
        }}
        onKeyDown={() => setOpen(!open)}
        aria-hidden
        onClick={() => setOpen(!open)}
      >
        <Stack direction={'row'} sx={{ width: '100%' }} justifyContent={'space-between'}>
          <Stack direction={'row'}>
            <QuestionIcon />
            <Typography sx={{ color: '#222', fontWeight: 700, fontSize: '14px' }} mx={2}>
              {title}
            </Typography>
          </Stack>
          {open ? <ArrowUpward color="#475466" /> : <ArrowDownward color="#475466" />}
        </Stack>

        {open && (
          <Typography color="#475466" fontWeight={600} mt={2} fontSize={14}>
            {description}
          </Typography>
        )}
      </div>
    </>
  );
};
